import { render, staticRenderFns } from "./PromoteSemiAnnualInsight.vue?vue&type=template&id=21463ee5&scoped=true"
import script from "./PromoteSemiAnnualInsight.vue?vue&type=script&lang=js"
export * from "./PromoteSemiAnnualInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21463ee5",
  null
  
)

export default component.exports